import React from 'react';
import { FormErrorMessage } from '@chakra-ui/react';
import { get, isObject } from 'lodash';

export const Error = ({
  errors,
  t,
  name,
}: {
  errors: any;
  t: any;
  name: string;
}) => {
  const complexObjectError: any =
    get(errors, name) &&
    isObject(get(errors, name)) &&
    Object.values(get(errors, name) || {})[0];

  return (
    <>
      {!!complexObjectError?.message && (
        <FormErrorMessage>
          {t?.(`${complexObjectError?.message}`) || complexObjectError?.message}
        </FormErrorMessage>
      )}
      <FormErrorMessage>
        {String(
          t?.(`${get(errors, name)?.message}`) || get(errors, name)?.message,
        )}
      </FormErrorMessage>
    </>
  );
};
